if (!('popover' in HTMLElement.prototype)) {
  import('@oddbird/popover-polyfill')
}

if (!('anchorName' in document.documentElement.style)) {
  import('@oddbird/css-anchor-positioning')
}

export {}
